var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAppointments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.305,
    height: 17.305,
    viewBox: "0 0 17.305 17.305",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-calendar",
    "data-name": "Icon ionic-md-calendar",
    d: "M18.2,13.873H13.873V18.2H18.2ZM16.758,4.5V5.942H9.547V4.5H7.384V5.942H6.3a1.808,1.808,0,0,0-1.8,1.8V20a1.808,1.808,0,0,0,1.8,1.8H20A1.808,1.808,0,0,0,21.8,20V7.745a1.808,1.808,0,0,0-1.8-1.8H18.921V4.5ZM20,20H6.3V10.448H20Z",
    transform: "translate(-4.5 -4.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAppointments);
export default __webpack_public_path__ + "static/media/icon-appointments.31a55c55d87350253860b0fbe565fbaf.svg";
export { ForwardRef as ReactComponent };